import { formatPercentNum, formatNum } from '@/pages/dashboard/utils/utils';
import {useIntl} from 'umi'
import moment from 'moment';
import { FORM_MAP } from './constant';

const getTableOptionKey = (param) => {
  return {
    today_key: param.today_key,
    lastday_key: param.lastday_key,
    contrastday_key: param.contrastday_key,
  };
}

const getTableOptionHeader = (param, filterState) => {
  return {
    today_date: param.today_key !== '-' ? param.today_key.slice(0, 4) + '-' + param.today_key.slice(4, 6) + '-' + param.today_key.slice(6, 8) : filterState?.singleDaily,
    lastday_date: param.lastday_key !== '-' ? param.lastday_key.slice(0, 4) + '-' + param.lastday_key.slice(4, 6) + '-' + param.lastday_key.slice(6, 8) : moment(filterState?.singleDaily).subtract(1, 'd').format("YYYY-MM-DD"),
    contrastday_date: param.contrastday_key !== '-' ? param.contrastday_key.slice(0, 4) + '-' + param.contrastday_key.slice(4, 6) + '-' + param.contrastday_key.slice(6, 8) : filterState?.contrastDaily,
  };
}

/**
 * 获取D2/D3/D7表格配置
 * @param {object} key 配置项key
 * @param {object} header 配置项header
 * @param {object} filterState 筛选器内容
 * @returns 配置项
 */
const getTableOption = (key, header, filterState) => {
  const { formatMessage } = useIntl();
  return [
    {
      key: "time",
      align: "center",
      fixed: "left",
      width: 100,
      header: formatMessage({id: 'realtime_by_country_table_time'}),
      render: cvm => (<span>{cvm.time}</span>),
    },
    {
      key: key.today_key || '-',
      align: "center",
      width: 100,
      header: header.today_date || filterState?.singleDaily/* "Today" */,
      render: cvm => (<span>{formatPercentNum(parseFloat(cvm.line_dot))}</span>),
    },
    {
      key: key.lastday_key || '-',
      align: "center",
      width: 100,
      header: header.lastday_date || moment(filterState?.singleDaily).subtract(1, 'd').format("YYYY-MM-DD")/* "Last day" */,
      render: cvm => (<span>{formatPercentNum(parseFloat(cvm.line_dot_last))}</span>),
    },
    {
      key: key.contrastday_key || '-',
      align: "center",
      width: 100,
      header: header.contrastday_date || filterState?.contrastDaily/* "Last week(Contrast day)" */,
      render: cvm => (<span>{formatPercentNum(parseFloat(cvm.line_dot_contrast))}</span>),
    },
  ];
}

/**
 * 获取Revenue表格配置
 * @param {object} key 配置项key
 * @param {object} header 配置项header
 * @param {object} filterState 筛选器内容
 * @returns 配置项
 */
const getTableOptionRevenue = (key, header, filterState) => {
  const { formatMessage } = useIntl();
  return [
    {
      key: "time",
      align: "center",
      fixed: "left",
      width: 100,
      header: formatMessage({id: 'realtime_by_country_table_time'}),
      render: cvm => (<span>{cvm.time}</span>),
    },
    {
      key: key.today_key || '-',
      align: "center",
      width: 100,
      header: header.today_date || filterState?.singleDaily/* "Today" */,
      render: cvm => (<span>{formatNum(cvm.line_dot)}</span>),
    },
    {
      key: key.lastday_key || '-',
      align: "center",
      width: 100,
      header: header.lastday_date || moment(filterState?.singleDaily).subtract(1, 'd').format("YYYY-MM-DD")/* "Last day" */,
      render: cvm => (<span>{formatNum(cvm.line_dot_last)}</span>),
    },
    {
      key: key.contrastday_key || '-',
      align: "center",
      width: 100,
      header: header.contrastday_date || filterState?.contrastDaily/* "Last week(Contrast day)" */,
      render: cvm => (<span>{formatNum(cvm.line_dot_contrast)}</span>),
    },
  ];
}

// 判断日期筛选器是否改变了默认值
const isChangeDefaultDate = (newValue, defaultValue) => {
  // 只有当日期为今天, 且对比日为上周同一天的时候, 图例才显示Same ....
  return !(newValue[FORM_MAP.SINGLE_TIME] === defaultValue[FORM_MAP.SINGLE_TIME] && newValue[FORM_MAP.CONTRAST_DAY] === defaultValue[FORM_MAP.CONTRAST_DAY])
}

/**
 * 补齐 实时页面的事件详情数据数量
 * @param data 事件详情数据
 * @param interval 间隔 (分钟)
 */
const LAST_MOMENT_MAP = {
  288: '23:59:00',
  287: '23:55:00',
  143: '23:50:00',
}
const fillRealtimeEventData = (data = [], interval, lastIndex) => {
  const count = 60 / Number(interval)
  const total = count * (data.length - 1)
  const fillData = new Array(total)
  fillData.fill({})
  data.forEach((item, index) => {
    fillData[index * count] = item
  })
  fillData[lastIndex] = { ...data[data.length - 1] }
  fillData[lastIndex].time = LAST_MOMENT_MAP[lastIndex]
  return fillData
}

export {
  getTableOptionKey,
  getTableOptionHeader,
  getTableOption,
  getTableOptionRevenue,
  isChangeDefaultDate,
  fillRealtimeEventData,
}
